import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PublicIcon from "@mui/icons-material/Public";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PeopleAltIcon from "@mui/icons-material/People";
import "../scss/pages/logistics.scss";
// Import Global SCSS File

const logisticsStats = [
  {
    icon: <TrendingUpIcon fontSize="large" />,
    value: "10 Million",
    label: "PKr Turnover",
  },
  {
    icon: <ApartmentIcon fontSize="large" />,
    value: "2",
    label: "Offices ",
  },
  { icon: <PublicIcon fontSize="large" />, value: "57", label: "Countries" },
  {
    icon: <LocalShippingIcon fontSize="large" />,
    value: "1000",
    label: "Shipments per Year",
  },
  {
    icon: <PeopleAltIcon fontSize="large" />,
    value: "12",
    label: "Employees",
  },
];

const LogisticsInfo = () => {
  return (
    <Box className="container">
      {/* Stats Section */}
      <Grid container spacing={4} justifyContent="center">
        {logisticsStats.map((stat, index) => (
          <Grid item key={index} xs={12} sm={6} md={2.4}>
            <Card className="card">
              <CardContent>
                <Box className="iconBox">{stat.icon}</Box>
                <Typography variant="h5" className="heading" mt={2}>
                  {stat.value}
                </Typography>
                <Typography variant="body2" className="text">
                  {stat.label}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Facts & Figures */}
      <Box textAlign="left" mt={6}>
        <Typography variant="h5" className="heading">
          Facts & Figures
        </Typography>
        <Typography variant="body1" mt={1} className="text">
          Today, Al Hamd Marind & Trading Worldwide Logistics operates in 57
          countries with 2 branches and over 12 employees worldwide. In 2023,
          the Al Hamd Marind & Trading Group generated a revenue of 10 billion
          revenue.
        </Typography>
      </Box>

      {/* Downloads Section */}
      <Box textAlign="left" mt={4}>
        <Typography variant="h6" className="heading">
          Downloads
        </Typography>
        <Button variant="contained" className="buttonPrimary">
          Sustainability Report
        </Button>
        <Button variant="outlined" className="buttonSecondary">
          Certificates
        </Button>
      </Box>
    </Box>
  );
};

export default LogisticsInfo;
